export default __webpack_public_path__ + "static/media/milestone 100.3ef9d17c.svg";